import React from "react";
import { BaseControlQuestionProps } from "./type";
import { Question } from "../question";
import { TextArea } from "component-library";
import { TextAreaQuestion as TextAreaQuestionType } from "@shared/types";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

export const TextAreaQuestion: React.FC<
  BaseControlQuestionProps & Omit<TextAreaQuestionType, "type" | "required">
> = ({ position, id, rows, control, question, required }) => {
  const { i18n } = useTranslation();

  return (
    <Question
      id={id}
      question={<span>{question[i18n.language]}</span>}
      position={position}
      direction="column"
    >
      <Controller
        name={id}
        control={control}
        rules={{ required }}
        render={({ field, fieldState }) => (
          <TextArea
            rows={rows}
            error={fieldState.error?.message}
            value={field.value}
            onChange={field.onChange}
          />
        )}
      />
    </Question>
  );
};
